import { render, staticRenderFns } from "./BedUsageRateV2.vue?vue&type=template&id=a8c1f5dc&scoped=true"
import script from "./BedUsageRateV2.vue?vue&type=script&lang=js"
export * from "./BedUsageRateV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c1f5dc",
  null
  
)

export default component.exports